<template>
    <div :class="inputClass">
        <div :class="checkboxClass">
            <input
                :id="`${_uid}-input`"
                name="opt-in"
                :class="iconClass"
                type="checkbox"
                v-model="checked">
            <label
                :for="`${_uid}-input`"
                :class="labelClass">
                <slot/>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    data: () => {
        return {
            checked: false,
        };
    },
    props: {
        initialValue: {
            default: false,
            type: Boolean,
        },
        value: {
            default: false,
            type: Boolean,
        },
        option: {
            required: false,
            type: String,
        },
        shopCheckbox: {
            default: false,
            type: Boolean,
        },
        smallFont: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        inputClass() {
            return this.shopCheckbox ? 'shop__input' : 'input';
        },
        checkboxClass() {
            return this.shopCheckbox ? `shop__checkbox` : 'input__checkbox';
        },
        labelClass() {
            return this.shopCheckbox ? 'shop__checkbox__label' : `input__checkbox-label input__checkbox-label--align-top ${this.smallFont ? ' smallFont' : ''}`;
        },
        iconClass() {
            return this.shopCheckbox ? 'shop__checkbox__item' : 'input__checkbox-item';
        },
    },
    created() {
        this.$parent.$on('clear', this.clear);
        this.checked = this.initialValue;
    },
    methods: {
        clear() {
            this.checked = false;
        },
    },
    watch: {
        checked(value) {
            this.$emit('input', value);
            if (this.option) this.$emit('optionSelect', this.option, value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.checked = value;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.smallFont {
    font-size: 15px;
    line-height: 21px;
    color: #262323;
}
</style>
